import { Box, Typography, Grid } from '@mui/material';
import { useUserBalance } from 'modules/payments/hooks/use-user-balance';
import React, { FC, ReactNode } from 'react';
import { FormatCurrency, FormatCurrencyType, MutedText } from 'shared/components/Format/Currency';
import { ExchangeRate } from '../ExchangeRate';
import { useStyles } from './AvailableSingleCurrencyBalance.styles';
import { SystemCurrency } from '@okletsplay/core';

interface AvailableBalanceProps {
  subTitle?: string | ReactNode;
}

/**
 * TODO: OKLP-1894 OKLP-1895 Delete this component and use <AvailableBalance /> instead.
 */
export const AvailableSingleCurrencyBalance: FC<AvailableBalanceProps> = ({ subTitle }) => {
  const { classes } = useStyles();

  const { balanceInCrypto, balanceInUsd } = useUserBalance();

  return (
    <Box className={classes.root}>
      <Grid container columnSpacing={{ xs: 1, md: 2 }} alignItems="baseline">
        <Grid item xs={8} container className={classes.balanceContainer}>
          <Typography variant="h4" className={classes.amount}>
            <FormatCurrency
              amount={balanceInCrypto}
              type={FormatCurrencyType.Crypto}
              currency={SystemCurrency.OKLP}
            />
          </Typography>
          <Typography variant="h5" ml={1} className={classes.amount}>
            <MutedText>≈&nbsp;</MutedText>
            <FormatCurrency
              amount={balanceInUsd}
              type={FormatCurrencyType.FiatCode}
              currency="USD"
            />
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>Available Balance</Typography>
        </Grid>
        <Grid item xs={8} className={classes.exchangeRateContainer}>
          <Grid item>
            <ExchangeRate />
          </Grid>
        </Grid>
        {subTitle && (
          <Grid item xs={4}>
            <Typography variant="subtitle2" className={classes.hint}>
              {subTitle}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
